import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Modal from '@/features/shared/components/Modal/Modal';
import ParameterTableFilters from '@/features/parameter/components/ParameterTableFilters';
import ParameterTable from '@/features/parameter/components/ParameterTable';
import ParameterPagination from '@/features/parameter/components/ParameterPagination';
import ParameterForm from '@/features/parameter/components/ParameterForm';
import useParameters from '@/features/parameter/hooks/useParameters';
import { toast } from 'react-toastify';
import { IoMdAdd } from "react-icons/io";
const defaultFilters = {
    cle: '',
    type_param: '',
};
const ParametersPage = () => {
    const [filters, setFilters] = useState({ ...defaultFilters });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [showAll, setShowAll] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const { parameters, meta, loading, error, handleCreateParameter, handleUpdateParameter, handleDeleteParameter, refetchParameters, } = useParameters(currentPage, filters, showAll, rowsPerPage);
    const handleFilterChange = (filterName, value) => {
        setFilters((previous) => ({ ...previous, [filterName]: value }));
        setCurrentPage(1);
    };
    const handleToggleAll = (value) => {
        setShowAll(value);
        setCurrentPage(1);
    };
    const handleResetFilters = () => {
        setFilters({ ...defaultFilters });
        setCurrentPage(1);
    };
    const openCreateModal = () => {
        setSelectedParameter(null);
        setIsModalOpen(true);
        setErrorMessage(null);
    };
    const handleEdit = (parameter) => {
        setSelectedParameter(parameter);
        setIsModalOpen(true);
        setErrorMessage(null);
    };
    const handleDelete = async (id) => {
        const confirmDelete = window.confirm('Voulez-vous vraiment supprimer ce paramètre ?');
        if (!confirmDelete) {
            return;
        }
        try {
            setErrorMessage(null);
            await handleDeleteParameter(id);
            toast.success('Paramètre supprimé avec succès');
            refetchParameters();
        }
        catch (deleteError) {
            const message = deleteError instanceof Error ? deleteError.message : 'Suppression impossible.';
            setErrorMessage(message);
            toast.error(message);
        }
    };
    const handleSubmit = async (parameterPayload) => {
        try {
            setErrorMessage(null);
            if (selectedParameter) {
                await handleUpdateParameter({ id: selectedParameter.id, parameter: parameterPayload });
                toast.success('Paramètre mis à jour avec succès');
            }
            else {
                await handleCreateParameter(parameterPayload);
                toast.success('Paramètre créé avec succès');
            }
            setIsModalOpen(false);
            setSelectedParameter(null);
            refetchParameters();
        }
        catch (submitError) {
            const message = submitError instanceof Error ? submitError.message : "Enregistrement impossible.";
            setErrorMessage(message);
            toast.error(message);
        }
    };
    if (loading) {
        return _jsx("div", { className: "p-4", children: "Chargement des param\u00E8tres\u2026" });
    }
    if (error) {
        return (_jsxs("div", { className: "p-4 text-red-600", children: ["Erreur lors du chargement des param\u00E8tres : ", error, _jsx("button", { type: "button", onClick: () => refetchParameters(), className: "ml-4 rounded bg-blue-500 px-3 py-1 text-sm text-white transition hover:bg-blue-600", children: "R\u00E9essayer" })] }));
    }
    return (_jsxs("div", { className: "space-y-4", children: [_jsxs("div", { className: "flex col-auto gap-4 mb-2", children: [_jsx("h4", { className: "text-xl font-bold", children: "Param\u00E8tres d'application" }), _jsx("button", { onClick: openCreateModal, title: "Ajouter un param\u00E8tre", className: "rounded", children: _jsx(IoMdAdd, { className: "bg-blue-500 text-white hover:bg-blue-600" }) })] }), _jsx(ParameterTableFilters, { filters: filters, showAll: showAll, onFilterChange: handleFilterChange, onToggleAll: handleToggleAll, onResetFilters: handleResetFilters }), _jsx(ParameterTable, { parameters: parameters, onEdit: handleEdit, onDelete: handleDelete }), !showAll && meta && meta.totalPages && meta.totalPages > 1 && (_jsx(ParameterPagination, { currentPage: meta.page ?? 1, totalPages: meta.totalPages, limit: rowsPerPage, onPageChange: (page) => setCurrentPage(page), onLimitChange: (value) => {
                    setRowsPerPage(value);
                    setCurrentPage(1);
                } })), isModalOpen && (_jsx(Modal, { onClose: () => setIsModalOpen(false), children: _jsx(ParameterForm, { initialData: selectedParameter ?? undefined, onSubmit: handleSubmit, onCancel: () => setIsModalOpen(false) }) })), errorMessage && (_jsx("div", { className: "rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700", children: errorMessage }))] }));
};
export default ParametersPage;
